"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC20__factory = exports.erc721Sol = exports.erc1155Sol = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
exports.erc1155Sol = require("./ERC1155.sol");
exports.erc721Sol = require("./ERC721.sol");
var ERC20__factory_1 = require("./ERC20__factory");
Object.defineProperty(exports, "ERC20__factory", { enumerable: true, get: function () { return ERC20__factory_1.ERC20__factory; } });
//# sourceMappingURL=index.js.map